import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-filling-guidance',
  templateUrl: './e-filling-guidance.component.html',
  styleUrls: ['./e-filling-guidance.component.css']
})
export class EfillingGuidanceComponent implements OnInit {

  constructor () { }

  ngOnInit () {
  }

}
